import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { variables } from '../Variables/Variable';
import { toast } from 'react-toastify';
import { useContext } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";
import ReCaptcha from '../Components/ReCaptcha';

const CategoryDetails = () => {
    const { setDynamicMeta } = useContext(MetadataContext);
    const ID = useParams();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [captchaToken, setCaptchaToken] = useState("");
    const [show, setShow] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const [productDetails, setProductDetails] = useState({
        AlbumImages: [],
        CustomFields: [],
        Details: {
            AuthorId: 0,
            AuthorName: "",
            ContentId: 15,
            ContentTitle: "Adalya Gris Mt",
            ImageUrl: "",
            MenuId: 13,
            MenuName: "Tiles",
            SmallDescription: "",
            Description: "",
            SubTitle: "",
            ThumbnailUrl: "",
            MetaTitle: "",
            MetaDescription: "",
            MetaKeyword: "",
            Url: null,
        }
    });
    var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    function isValid() {

        //Registration
        if (email == "" || name == "" || phone == "" || message == "") {
            toast.error("please fill required fields");
            return false;
        } else if (!emailregx.test(email)) {
            toast.error("Bad email format");
        } else if (captchaToken == "") {
            toast.error("Please verify that you are not a robot");
            return false;
        } else {
            return true;
        }
    }

    useEffect(() => {
  const p = productDetails?.Details;

  if (p?.ContentTitle) {
    setDynamicMeta({
      Title:
        p.MetaTitle ||
        `Home Depot | ${p.ContentTitle} - ${p.MenuName}`,

      Description:
        p.MetaDescription ||
        p.SmallDescription ||
        `Discover ${p.ContentTitle} from Home Depot. Premium tiles, ceramics, and sanitary ware for modern homes.`,

      Keywords:
        p.MetaKeyword ||
        `${p.ContentTitle}, ${p.MenuName}, tiles, ceramics, sanitary ware, Home Depot`,

      Url: window.location.href,
      Type: "product",

      Image: p.ImageUrl
        ? variables.PHOTO_URL + p.ImageUrl.replace(/ /g, "%20")
        : "",

      TwitterCard: "summary_large_image",
    });
  }

  // 🔥 cleanup on unmount / route change
  return () => setDynamicMeta(null);
}, [productDetails]);

    // "/en"
    const getProductDetails = async () => {
        await fetch(variables.API_URL + "Content/GetContentDetails/" + ID.ContentId + "/en", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
    console.log(Result);
    setProductDetails(Result);
});
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isValid()) {
            var rfNumber;
            if (!productDetails?.Details?.ReferenceNumber) {
                const referenceField = productDetails?.CustomFields?.find(
                    x => x.CustomFieldTypeName === "Reference Number"
                );
                rfNumber = referenceField?.CustomFieldDataName;
            } else{
                rfNumber = productDetails.Details.ReferenceNumber;
            }
    
            fetch(variables.API_URL + "Contact/SendQuotationRequest/", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": variables.API_URL,
                },
                body: JSON.stringify({
                    Name: name,
                    Email: email,
                    PhoneNumber: phone,
                    Message: message,
                    ContentTitle: ID.ContentTitle,
                    ReferenceNumber: rfNumber,
                    RecaptchaToken: captchaToken,
                }),
            })
                .then((Response) => {
                    if (Response.ok) {
                        toast.success("Email sent Sucessfully");
                        setName(""); setPhone(""); setEmail(""); setMessage("");
                        setCaptchaToken("");
                        if (window.grecaptcha) window.grecaptcha.reset();
                        return Response.json();
                    } else {
                        toast.error("Verification failed, please try again");
                        setCaptchaToken("");
                        if (window.grecaptcha) window.grecaptcha.reset();
                    }
                })
        }
    }
    // const DownloadImage = () => {
    //     const test = "https://api.playmegastorelb.com/Uploads/Images/08_17_2022/1857a8f3-51e9-47d1-8d5c-d53a045f16ed.jpg"
    //     saveAs(test,ID.ContentTitle);
    // }

    useEffect(() => {
        getProductDetails();
    }, [])
    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header page-header--services-single-one">
                <div className="page-header__bg" style={{ backgroundImage: `url(${(variables.PHOTO_URL + productDetails.Details.ImageUrl.replace(/ /g, '%20'))})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper text-center">
                                <div className="page-header__content">
                                    <h2>{productDetails.Details.ContentTitle}</h2>
                                    <p>{productDetails.Details.SubTitle}</p>
                                    <div className="number">
                                        <a hreflang="en" href={"/en/v/" + ID.MenuTitle + "/" + ID.MenuId}>{ID.MenuTitle}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}




            {/* <!--Start Services Single One--> */}
            <section className="services-single-one clearfix">
                <div className="container">
                    <div className="row">
                        {/* <!--Start Services Single One Content--> */}
                        <div className="col-12 col-xl-8 col-lg-7">
                            <div className="services-single-one__content">

                                <div className="title">
                                    <h2>{ID.ContentTitle}</h2>
                                </div>

                                <div className="text1">
                                    <p dangerouslySetInnerHTML={{ __html: productDetails.Details.SmallDescription }}>
                                        {/* {productDetails.Details.SmallDescription} */}
                                    </p>
                                </div>

                                {/* <div className="text2">
                                    <p>
                                        {ID.MenuTitle}
                                    </p>
                                </div> */}

                                <div className="services-single-one__content-list">
                                    <ul>
                                        {productDetails.CustomFields.map((detail) => {
                                            return (
                                                <li key={detail.ContentCustomFiledId}>
                                                    <div className="icon">
                                                        <span className="fa fa-check"></span>
                                                    </div>

                                                    <div className="text">
                                                        <p>{detail.CustomFieldTypeName + ": " + detail.CustomFieldDataName}</p>
                                                    </div>
                                                </li>
                                            )
                                        })}


                                        {productDetails && productDetails.Details && productDetails.Details.ReferenceNumber && (
                                            <li>
                                                <div className="icon">
                                                    <span className="fa fa-check"></span>
                                                </div>
                                                <div className="text">
                                                    <p>{"Reference Number: " + productDetails.Details.ReferenceNumber}</p>
                                                </div>
                                            </li>
                                        )}

                                        {productDetails && productDetails.Details && productDetails.Details.Dimension && (
                                            <li>
                                                <div className="icon">
                                                    <span className="fa fa-check"></span>
                                                </div>
                                                <div className="text">
                                                    <p>{"Dimensions: " + productDetails.Details.Dimension}</p>
                                                </div>
                                            </li>
                                        )}

                                    </ul>
                                </div>
                                <div className="text1 mt-5">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: productDetails.Details.Description.replace(/\n/g, '<br/>')
                                        }}
                                    ></p>
                                </div>
                                <div className="services-single-one__content-bottom">
                                    <div className="">
                                        <img className="product-detail__img" src={(variables.PHOTO_URL + productDetails.Details.ImageUrl.replace(/ /g, '%20'))} alt={productDetails.Details.Title || ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--End Services Single One Content--> */}



                        {/* <!--Start Services Single Sidebar--> */}
                        <div className="col-12 col-xl-4 col-lg-5">
                            <div className="services-single__sidebar">

                                {/* <!--Start Services Single Sidebar Single--> */}
                                <div className="services-single__sidebar-single wow fadeInUp animated" data-wow-delay="0.0s"
                                    data-wow-duration="1200ms">
                                    <div className="services-single__sidebar-services">
                                        <h2 className="services-single__sidebar__title">Request a quotation</h2>
                                        <div className='row mt-3'>
                                            <div className='col-12'>
                                                <label className='sec-title__tagline'>{ID.ContentTitle}</label>
                                            </div>
                                        </div>
                                        <form onSubmit={handleSubmit}>
                                            <div className="row mt-2">
                                                <div className="col-xl-12 col-lg-12">
                                                    <input type="text" className='quotationBox' placeholder="Full Name" name="name" onChange={(e) => setName(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12">
                                                    <input type="text" className='quotationBox' placeholder="Phone Number" name="phone" onChange={(e) => setPhone(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12">
                                                    <input type="email" className='quotationBox' placeholder="E-mail" name="mail" onChange={(e) => setEmail(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12">
                                                    <textarea name="message" className='quotationBox' placeholder="Your Message here" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12" style={{ marginBottom: 20 }}>
                                                    <ReCaptcha onChange={setCaptchaToken} />
                                                </div>
                                            </div>
                                            <div className='row' style={{ justifyContent: "center" }}>
                                                <button type="submit" className="thm-btn comment-form__btn" style={{ width: "150px" }}>
                                                    Send
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/* <!--End Services Single Sidebar Single--> */}



                                {/* <!--Start Services Single Sidebar Single--> */}
                                <div className="services-single__sidebar-single wow fadeInUp animated" data-wow-delay="0.3s"
                                    data-wow-duration="1200ms">
                                    <div className="services-single__sidebar-contact-info text-center">
                                        <div className="icon-bg"><img src="/assets/images/icon/phone.png" alt="" /></div>

                                        {/* <div className="icon">
                                            <span className="icon-wood-board"></span>
                                        </div> */}

                                        <h2 className="services-single__sidebar-contact-info-title">Quality Flooring at <br /> a
                                            Fair Price</h2>
                                        <p className="services-single__sidebar-contact-info-text">Call us for a FREE quote!</p>
                                        <a hreflang="en" href="tel:01558517">+ 961 1 558517/+961 8 554546</a>
                                    </div>
                                </div>
                                {/* <!--End Services Single Sidebar Single--> */}

                            </div>
                        </div>
                        {/* <!--End Services Single Sidebar--> */}

                    </div>
                </div>
            </section>
            {/* <!--End Services Single One--> */}

            {productDetails.AlbumImages.length !== 0 && (
                <section className="product-one">
                    <div className="container">
                        <div className="sec-title text-center">
                            <span className=" sec-title__tagline">{ID.ContentTitle}</span>
                            <h2 className="sec-title__title">Product Images</h2>
                        </div>
                        <div className="row">
                            {/* <!--Start Single Product One--> */}
                            {productDetails.AlbumImages.map((album) => {

                                return (
                                    <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInLeft" data-wow-delay="0ms"
                                        data-wow-duration="1500ms" key={album.AlbumItemId}>
                                        <div className="product-one__single">
                                            <div className="product-one__single-img">
                                                {/* <a hreflang="en" href={`${variables.PHOTO_URL + album.ImageUrl}`} target="_blank">
                                                <img src={variables.PHOTO_URL + album.ImageUrl} alt="" />
                                                </a> */}
                                                <a hreflang="en" href={variables.PHOTO_URL + album.ImageUrl} target="_blank">
                                                    <img id='test' src={variables.PHOTO_URL + album.ImageUrl} alt="" style={{ width: '400px', height: '300px' }} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                            {/* <!--End Single Product One--> */}
                        </div>
                    </div>
                </section>
            )}
            {/* <Modal
                className='categoryDetail-imageModal'
                show={show}
                fullscreen={false}
                onHide={() => setShow(false)}
            >
                <Modal.Header closeButton className='categoryDetail-imageModal-header'>
      
                </Modal.Header>
                <Modal.Body >
                        <img src={variables.PHOTO_URL + imageUrl} style={{width: "100%", height: "100%"}} />
                </Modal.Body>
            </Modal> */}

            {/* <!--Start Work One--> */}
            {/* <section className="work-one work-one--services work-one--services-two">
                <div className="container">
                    <div className="sec-title text-center">
                        <span className="sec-title__tagline">OUR PROCESS</span>
                        <h2 className="sec-title__title">Our Concrete Finishing Services</h2>
                    </div>
                    <div className="row">


                        <div className="col-6 col-sm-3 col-xl-3 col-lg-3 wow animated fadeInUp" data-wow-delay="0.1s">
                            <div className="work-one__single text-center">
                                <div className="work-one__single-icon">
                                    <span className="icon-wood-board"></span>
                                    <div className="count-box"></div>
                                </div>
                                <h2><a hreflang="en" href="#">Color Board</a></h2>
                            </div>
                        </div>


                        <div className="col-6 col-sm-3 col-xl-3 col-lg-3 wow animated fadeInUp" data-wow-delay="0.1s">
                            <div className="work-one__single text-center">
                                <div className="work-one__single-icon bg2">
                                    <span className="icon-wood"></span>
                                    <div className="count-box"></div>
                                </div>
                                <h2><a hreflang="en" href="#">Dimension</a></h2>
                            </div>
                        </div>


                        <div className="col-6 col-sm-3 col-xl-3 col-lg-3 wow animated fadeInUp" data-wow-delay="0.1s">
                            <div className="work-one__single text-center">
                                <div className="work-one__single-icon bg3">
                                    <span className="icon-wheel-saw"></span>
                                    <div className="count-box"></div>
                                </div>
                                <h2><a hreflang="en" href="#">Installation</a></h2>
                            </div>
                        </div>


                        <div className="col-6 col-sm-3 col-xl-3 col-lg-3 wow animated fadeInUp" data-wow-delay="0.1s">
                            <div className="work-one__single text-center">
                                <div className="work-one__single-icon bg4">
                                    <span className="icon-chisel"></span>
                                    <div className="count-box"></div>
                                </div>
                                <h2><a hreflang="en" href="#">Finishing</a></h2>
                            </div>
                        </div>

                    </div>
                </div>
            </section> */}
            {/* <!--End Work One--> */}
        </>
    )
}

export default CategoryDetails